import React from "react";
import { Col, Container, Row, Button } from "react-bootstrap";

export const SectionEight = () => {
  return (
    <Container fluid>
      <Container className="py-5">
        <div className="bgBlack p-2 py-4 rounded-md">
          <Row className="align-items-center justify-center">
            <Col lg="5">
              <div className="webkit">
                <h2 className="text-2xl text-white font-extrabold">
                  STAY CONNECT WITH US!
                </h2>
              </div>
            </Col>
            <Col lg="7">
              <div className="dNoneRes">
                <input
                  className="form-control-new"
                  placeholder="Enter Profession, Company Name or Keywords."
                ></input>

                <button className="btngreenform">Subscribe Now</button>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Container>
  );
};
